{
  "endTime": "Ora de sfârșit",
  "startTime": "Ora de început",
  "time": "Ora"
}
